import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import {
  ENDPOINT_GET_SEBRAE,
  ENDPOINT_MANAGER_SEARCH,
  ENDPOINT_RESEND_EMAIL_VALIDATE_USER,
  ENDPOINT_SEND_EMAIL_VALIDATE_USER,
  ENDPOINT_USER,
  ENDPOINT_USER_CHECK,
  ENDPOINT_USER_ME,
} from './constants';

export function useUserService() {
  const { backendGet, backendPut, backendPost } = Sebrae.useBackend();

  const getSebrae = React.useCallback(
    () => backendGet(ENDPOINT_GET_SEBRAE),
    [backendGet],
  );

  const getCheck = React.useCallback(
    () => backendGet(ENDPOINT_USER_CHECK),
    [backendGet],
  );

  const getManagersByName = React.useCallback(
    (params) => backendGet(ENDPOINT_MANAGER_SEARCH, { ...params }),
    [backendGet],
  );

  const gerInformationsManagerAuth = React.useCallback(
    () => backendGet(ENDPOINT_USER_ME),
    [backendGet],
  );

  const putGrantAccess = React.useCallback(
    (cpf) => backendPut(`${ENDPOINT_USER}/${cpf}/grant-access`),
    [backendPut],
  );

  const postResendEmailValidateUser = React.useCallback(
    () => backendPost(ENDPOINT_RESEND_EMAIL_VALIDATE_USER),
    [backendPost],
  );

  const postSendEmailValidateUser = React.useCallback(
    (email) => backendPost(`${ENDPOINT_SEND_EMAIL_VALIDATE_USER}/${email}`),
    [backendPost],
  );

  return {
    getSebrae,
    getCheck,
    putGrantAccess,
    postResendEmailValidateUser,
    postSendEmailValidateUser,
    getManagersByName,
    gerInformationsManagerAuth,
  };
}
